import { TablePaginationConfig } from "antd";

export const DEFAULT_LIMIT = 50;
export const DEFAULT_PAGE_SIZE_OPTIONS = [DEFAULT_LIMIT, 100];
export const DEFAULT_PAGINATION_SETTINGS: Partial<TablePaginationConfig> = {
  position: ["bottomLeft"],
  showSizeChanger: true,
  pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
};
